export default "__VITE_ASSET__CLIIUE5M__"